import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { purple } from '@mui/material/colors';
import {
  useMediaQuery,
  Typography,
  Box,
  FormControl,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Chip,
} from '@mui/material';
import { actions } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getPhraseFormat } from '../../../utils/utils';
import { toUpper, isEmpty } from 'lodash';
const MySwal = withReactContent(Swal);

const useStyles = (small) => {
  return makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    training: {
      paddingBlock: 32,
    },
    title: {
      fontSize: 24,
    },
    caseItem: {
      padding: 16,
    },
    specialtyItem: {
      padding: 16,
      display: 'flex',
      alignItems: 'center',
    },
    sectionRef: {
      fontWeight: 'bold',
    },
    synonymTag: {
      marginRight: 8,
      backgroundColor: purple[500],
      '&:hover': {
        backgroundColor: purple[300],
      },
      cursor: 'pointer',
      color: 'white',
      borderRadius: 4,
      padding: 4,
    },
    chipActive: {
      background: theme.palette.primary.main,
      color: 'white',
    },
    chip: {
      cursor: 'pointer',
      '&:hover': {
        opacity: '.7',
      },
    },
    finishButton: {
      background: theme.palette.secondary.main,
      color: 'white',
      '&:hover': {
        background: theme.palette.secondary.light,
      },
    },
  }));
};

export default function IntentsHandler() {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const organizations = useSelector((state) => state.app.organizations);
  const organization = useSelector((state) => state.app.organization);
  const [type, setType] = useState('train_with_phrase');

  const firebase = useFirebase();
  const appDispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const projectId = process.env.REACT_APP_PROJECT_ID;

  // df changes handler
  const [intent, setIntent] = useState();
  const [clientsToChange, setClientsToChange] = useState({});
  const [isGlobalChange, setIsGlobalChange] = useState(true);

  const handleChangeIntent = () => {
    if (!intent.name) {
      return appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: `Debe ingresar el nombre de la intención`,
          snackbarSeverity: 'error',
        },
      });
    }
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(async (idToken) => {
        let clients = [];
        if (isGlobalChange) {
          clients = organizations.map((e) => e.id);
        } else clients = Object.keys(clientsToChange).filter((key) => !!clientsToChange[key]);

        const payload = {
          intentName: intent.name,
          clients,
          type,
        };
        switch (type) {
          case 'train':
          case 'import_intent': {
            payload.targetOrganization = organization.id;
            break;
          }
          case 'train_with_phrase':
          default: {
            const trainPhrase = getPhraseFormat(intent.phrase, intent.params);
            payload.trainPhrase = trainPhrase;
            break;
          }
        }
        axios(`https://us-central1-${projectId}.cloudfunctions.net/dialogflow/intent`, {
          method: 'post',
          headers: {
            Authorization: `bearer ${idToken}`,
          },
          data: payload,
        })
          .then(() => {
            appDispatch({
              type: actions.alert,
              alert: {
                snackbarOpen: true,
                snackbarMessage: `Las intenciones se actualizaran, en los proximos minutos vera los cambios`,
                snackbarSeverity: 'success',
              },
            });
            setIntent(null);
          })
          .catch(() => {
            appDispatch({
              type: actions.alert,
              alert: {
                snackbarOpen: true,
                snackbarMessage: `Ocurrio un error al tratar de actualizar los agentes, intente mas tarde`,
                snackbarSeverity: 'error',
              },
            });
          })
          .finally(() => {
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
          });
      });
  };

  const entitiesNames = {
    Professional: 'Profesional',
    Specialty: 'Especialidad',
  };

  const handleSelectText = () => {
    const selectedText = window.getSelection().toString();
    if (selectedText) {
      MySwal.fire({
        title: 'Seleccione el tipo de entidad',
        input: 'select',
        inputOptions: entitiesNames,
        inputPlaceholder: 'Seleccione entidad',
        showCancelButton: true,
      }).then((res) => {
        // eslint-disable-next-line no-console
        console.log(res);
        if (res.isConfirmed) {
          setIntent({
            ...intent,
            params: [
              ...(intent.params || []),
              {
                value: selectedText,
                entity: res.value,
              },
            ],
          });
        }
      });
    }
  };

  return (
    <Box mt={4} mb={2}>
      <Typography className={classes.sectionRef}>MODIFICAR INTENCIONES</Typography>
      <br />
      <Typography>
        <b>Entrenar una intención</b>: sirve para entrenar una intención modificando todas las
        frases de entranmiento que tengan profesionales/especialidades/os que no sean correctas
      </Typography>
      <Typography>
        <b>Entrenar con una frase</b>: sirve para entrenar una intención con una frase de
        entrenamiento. Se debe colocar el nombre de la intención. En la frase de entrenamiento se
        puede seleccionar una parte y colocar a que entidad corresponde (profesional/especialidad)
      </Typography>
      <br />
      <Typography>
        <b>Importar una intención</b>: sirve para importar una intención en otros agentes. Solo se
        necesita el nombre de la intención. El agente será el definido para el cliente en cuestion
        (es decir, si estoy en ASISTIR se tomara la intención del agende de ASISTIR). Esto es util
        ya que si la intención tiene parametros (especialidad/profesional/especialidad compuesta)
        seran configurados con los que tiene el agente de destino
      </Typography>
      <br />
      <Typography>En ambos modos se puede modificar mas de un cliente a la vez</Typography>
      <Box my={2} display="flex">
        <FormControlLabel
          control={<Checkbox checked={type === 'train'} onChange={(e) => setType('train')} />}
          name="scope"
          label="Entrenar una intención"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={type === 'train_with_phrase'}
              onChange={(e) => setType('train_with_phrase')}
            />
          }
          name="scope"
          label="Entrenar con una frase"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={type === 'import_intent'}
              onChange={() => {
                setType('import_intent');
                setIntent(null);
              }}
            />
          }
          name="scope"
          label="Importar una intención"
        />
      </Box>
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={isGlobalChange}
              onChange={(e) => setIsGlobalChange(e.target.checked)}
            />
          }
          name="scope"
          label="Modificar todos los clientes"
        />
      </Box>
      {!isGlobalChange && (
        <Box mt={1} display="flex" flexWrap="wrap">
          {organizations
            .filter((e) => e.disabled === false)
            .filter((e) => e.provider && !isEmpty(e.provider.dfId?.trim()))
            .map((e) => (
              <Box
                key={e.id}
                mr={2}
                mb={1}
                onClick={() => {
                  setClientsToChange({ ...clientsToChange, [e.id]: !clientsToChange[e.id] });
                }}
              >
                <Chip
                  label={toUpper(e.name)}
                  className={
                    clientsToChange[e.id] ? `${classes.chip} ${classes.chipActive}` : classes.chip
                  }
                />
              </Box>
            ))}
        </Box>
      )}
      <Box display="flex" alignItems="center">
        <Box my={2}>
          <FormControl className={classes.formControl}>
            <TextField
              label="Nombre de la intención"
              value={(intent && intent.name) || ''}
              onChange={(e) => {
                setIntent({ ...intent, name: e.target.value });
              }}
            />
          </FormControl>
        </Box>
      </Box>
      {type === 'train_with_phrase' && (
        <Box my={2}>
          <FormControl fullWidth className={classes.formControl}>
            <TextField
              label="Frase de entrenamiento"
              value={(intent && intent.phrase) || ''}
              onChange={(e) => {
                setIntent({ ...intent, phrase: e.target.value });
              }}
              onMouseUp={handleSelectText}
            />
          </FormControl>
        </Box>
      )}
      {intent && intent.params && intent.params.length > 0 && (
        <Box mb={1}>
          <Typography>
            <b>Parametros</b>
          </Typography>
          {intent &&
            intent.params &&
            intent.params.map((param, index) => (
              <Typography
                key={index}
                onClick={() => {
                  setIntent({
                    ...intent,
                    params: intent.params.filter((e) => e.value !== param.value),
                  });
                }}
                sx={{ '&:hover': { opacity: '.7', cursor: 'pointer', color: 'red' } }}
              >
                {param.value} <span style={{ fontSize: 12 }}>({entitiesNames[param.entity]})</span>
              </Typography>
            ))}
        </Box>
      )}
      <Button
        variant="contained"
        className={classes.finishButton}
        onClick={handleChangeIntent}
        sx={{ mt: 2 }}
      >
        Entrenar
      </Button>
    </Box>
  );
}
